import _ from 'underscore';
import ko from 'knockout';
import $ from 'jquery';

class Parameter {
  constructor({ Key, Value, i18n }) {
    this.key = ko.observable(Key);
    this.val = ko.observable(Value);
    this.isValid = ko.observable(true);
    this.errorMessages = ko.computed(() => {
      const invalidChars = ['#', '/', ' '];
      const errors = [];
      const key = this.key();
      const value = this.val();

      if (value && !key) {
        errors.push(i18n.getString('Error_Campaign_API_KeyNullOrEmpty'));
      }
      if (_.some(invalidChars, c => _.contains(key, c))) {
        errors.push(i18n.getString('Error_Campaign_API_InvalidCharactersInKey'));
      }
      if (/\s/.test(value)) { // Validate value against white spaces
        errors.push(i18n.getString('Error_Campaign_API_InvalidCharactersInValue'));
      }
      this.isValid(!errors.length);
      return errors;
    });
  }
}

export default class CustomParams {
  constructor({
    customParameters = [],
    bulkEditMode,
    editMode,
    bulkEditShowAddLabel,
    bulkEditShowMatchCase,
    i18n,
    permissions,
    entityType,
    forceUseIncreasedCount,
    readOnly,
  }) {
    const params = customParameters;

    const paramsInitialLength = 1;
    while (params.length < paramsInitialLength) {
      params.push({
        Key: undefined,
        Value: undefined,
      });
    }

    this.bulkEditMode = bulkEditMode;

    this.editMode = ko.observable(editMode);

    this.isDisabled = ko.observable(false || readOnly);

    this.bulkEditShowAddLabel = ko.observable(bulkEditShowAddLabel);

    this.bulkEditShowMatchCase = ko.observable(bulkEditShowMatchCase);

    this.bulkEditMatchCaseSelected = ko.observable(false);

    let useIncreasedCount = !!forceUseIncreasedCount;

    if (!useIncreasedCount) {
      // Temporary check for MT staged release. Will remove after feature GA.
      const entityTypeLower = !entityType ? '' : entityType.toLowerCase();

      if (entityTypeLower === 'phase1entity' || entityTypeLower === 'campaign' || entityTypeLower === 'adgroup' || entityTypeLower === 'keyword' ||
          entityTypeLower === 'ad' || entityTypeLower === 'audience' || entityTypeLower === 'autotarget' || entityTypeLower === 'productgroup') {
        useIncreasedCount = true;
      } else {
        useIncreasedCount = permissions.IsCustomParameterCountIncreasePhase3Enabled;
      }
    }

    this.maxParameterCount = useIncreasedCount ? 8 : 3;
    this.valueMaxLength = ko.observable(useIncreasedCount ? 250 : 200);

    this.addCustomParamEntry = () => {
      this.parameters.push(new Parameter({
        Key: undefined,
        Value: undefined,
        i18n,
      }));
      $('.custom-param__key-field').last().focus();
    };

    this.removeCustomParamEntry = (index) => {
      this.parameters.splice(index, 1);
    };

    this.getInputAriaLabel = (index, isKey = true) => {
      const key = isKey ? i18n.getString('CustomParameters_Placeholder_Key') : i18n.getString('CustomParameters_Placeholder_Value');

      return (i18n.getString('BulkEdit_UrlOptions_CustomParameters_InputAriaLabel') || '').replace('{{key}}', key).replace('{{number}}', index + 1);
    };

    this.getRemoveButtonAriaLabel = index => (i18n.getString('BulkEdit_UrlOptions_CustomParameters_RemoveLineNumber') || '').replace('{{number}}', index + 1);

    this.parameters = ko.observableArray(_.map(params, p => new Parameter(_.extend({ i18n }, p))));

    this.showAddLable = ko.computed(() =>
      this.editMode() &&
      this.bulkEditShowAddLabel() &&
      this.parameters().length < this.maxParameterCount);

    this.errorMessages = ko.computed(() => {
      if (this.parametersError) {
        this.parametersError([]);
      }
      let keys = _.compact(_.invoke(this.parameters(), 'key'));
      keys = _.map(keys, key => key.toLowerCase());
      return _.unique(keys).length !== keys.length ?
        [i18n.getString('ErrorNumber_UniqueCustomParameterNames')] :
        '';
    });

    this.parameterArray = ko.computed(() => _.map(this.parameters(), param => ({
      Key: param.key(),
      Value: param.val(),
    })));

    this.parametersError = ko.observableArray();

    this.isValid = ko.computed(() => {
      if (this.parametersError) {
        this.parametersError([]);
      }
      return !this.errorMessages().length &&
        _.find(this.parameters(), p => p.errorMessages().length) === undefined;
    });

    this.showNone = ko.computed(() => !this.editMode() &&
      !_.find(this.parameters(), p => p.key() || p.val()));
  }
}
